import { render, staticRenderFns } from "./SocialMediaModal.vue?vue&type=template&id=5db2b24b&scoped=true&"
import script from "./SocialMediaModal.vue?vue&type=script&lang=js&"
export * from "./SocialMediaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db2b24b",
  null
  
)

export default component.exports